import { z } from "zod";
import { TaskV3_1 } from "../../Tasks/Types";
import { TaskId } from "../../Types";
export const TaskCount = z.number().int().nonnegative().brand();
export const TransitionSectionStats = z.object({
    sectionId: TaskId,
    title: z.string(),
    totalSubtasks: TaskCount,
    completedSubtasks: TaskCount,
});
export const TransitionProgress = z.object({
    transitionTaskId: TaskId,
    totalTasks: TaskCount,
    completedTasks: TaskCount,
    sections: TransitionSectionStats.array(),
});
export const TransitionTasksData = z.object({
    transitionTaskId: TaskId,
    rootTask: TaskV3_1,
    level1Tasks: TaskV3_1.array(),
    level2Tasks: TaskV3_1.array(),
    allTasks: TaskV3_1.array(),
});
//# sourceMappingURL=TransitionProgressSchemas.js.map